<template lang="pug">
.container(id="MediumInPlaylists-container")
  .header-container(v-if="!playlistsFullPath || playlistsFullPath.length === 0 || loading", id="MediumInPlaylists-mediumAppearancesHeader")
    p
      font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
      span &nbsp; {{ $t(`Loading medium usage. It can take some time with heavily used media.`) }}
  .header-container(v-if="playlistsFullPath && playlistsFullPath.length > 0" id="MediumInPlaylists-mediumAppearancesHeader")
    span.title
      font-awesome-icon(icon="broadcast-tower")
      span &nbsp; {{$t('Medium usage')}} &nbsp; &nbsp;
    el-checkbox(v-model='displayDetails')
      span {{ $t('Detailed view') }}
    el-radio-group(v-model='playlistScreensSwitch', size="mini")
      el-radio-button(id="MediumInPlaylists-screensButton" label='PlayListDesktop')
        span {{ $t('Screens') }} &nbsp;
        font-awesome-icon(icon="desktop")
      el-radio-button(id="MediumInPlaylists-playlistsButton" label='PlayList')
        span {{ $t('Playlists') }} &nbsp;
        font-awesome-icon(icon="film")
      el-radio-button(id="MediumInPlaylists-playlistsButton" label='PlayListLayout')
        span {{ $t('Layouts') }} &nbsp;
        font-awesome-icon(icon="layer-group")
      el-radio-button(id="MediumInPlaylists-playlistsButton" label='PlayListExtended')
        span {{ $t('Extensions') }} &nbsp;
        font-awesome-icon(icon="camera-retro")
      el-radio-button(id="MediumInPlaylists-libraryButton" label='PlayListLibraryRoot') {{ $t('') }}
        span {{ $t('Library') }} &nbsp;
        font-awesome-icon(icon="folder")
      el-radio-button(v-if='showMediumDuplicates', id="MediumInPlaylists-duplicatesButton", label='duplicates')
        span {{ $t('Duplicates') }} &nbsp;
        font-awesome-icon(icon="copy")
  .items-container
    .row(v-if='playlistsFullPath && (playlistsFullPath.length > tooManyAppearancesTreshhold) && !forceDisplayAll && this.items && this.items.length === 0')
      el-button(@click='toggleForceDisplayAll()', type='text', size='small')
        span.warning() {{ $t(`${$t('Too many appearances')}. ${$t('Click to expand list')}`) }}
          span &nbsp;
          font-awesome-icon(icon="chevron-right")
    .row(v-if='playlistsFullPath && playlistsFullPath.length > 0')
      el-input.searchByString-input(id="searchByString-input", v-model="searchByStringInput", size='mini', type='text', clearable, :placeholder='$t("min 4 chars")')
        el-button(slot="append" icon="el-icon-search", @click='fireSearchByString()', size='mini')
      span.warning(v-if='itemsCount && items') {{ `Showing ${items.length} of ${itemsCount} appearances. Please narrow your search.` }}
      span(v-if='!itemsCount && items') {{ `${items.length}`}} {{ $t('appearances')}}.
    .appearance-row(
      v-if='displayAppearances',
      v-for="(pl, itemindex) in items",
      :id="'MediumInPlaylists-appearanceRow' + pl.id",
      :class='{ danger: isExcepted(pl)}'
    )
      MediumIcon.icon.danger(:medium="pl", size='mini')
      span.danger(v-for="(pathItem, index) in pl.fullPath.mediaNames")
        el-button(v-if='index === 0',
        type="text",
        size="mini",
        @click="editPlayListInPlayItemContext(pl.fullPath.mediaIds[index], pl.fullPath.playlistitemsIds[index+1], pl.pathByPlaylistitemid, pl)",
        )
          | {{ nameOfDestopByLocalPlaylistId(pl) }}
          font-awesome-icon.slash(icon="chevron-right")
        el-button(v-if='index > 0 && index < pl.fullPath.mediaNames.length - 1',
        type="text",
        size="mini",
        :title="pl.originalPath && pl.originalPath[index] ? pl.originalPath[index] : '' "
        @click="editPlayListInPlayItemContext(pl.fullPath.mediaIds[index], pl.fullPath.playlistitemsIds[index+1], pl.pathByPlaylistitemid, pl)"
        )
          | {{pathItem}}
          font-awesome-icon.slash(icon="chevron-right")
        span.muted.subject-item(v-if='index === pl.fullPath.mediaNames.length - 1') {{ pathItem }}
      span.muted(v-if='displayDetails && (playlistScreensSwitch === "PlayList" || playlistScreensSwitch === "PlayListLayout")') &nbsp; ({{ pl.order }})
      PlayListEditorComponent(
        v-if="(playListEditorSelector === pl.pathByPlaylistitemid) && !onlyPreview",
        id="MediumInPlaylists-playlistEditor",
        :playList = "playlistEdited",
        :selectedPlayitemId = "playitemIdSelected",
        @loadEditMediumInMediaEditor="loadEditMediumInMediaEditor",
        @loadMediumUsageInMediaEditor="loadEditMediumInMediaEditor"
      )
</template>

<script>

import Vue from 'vue'
import MediumIcon from './../Common/MediumIcon'
import textUtils from './../Common/textUtils.mixin'

export default {
  props: ['medium', 'selectedPlayitemId', 'onlyPreview'],
  mixins: [textUtils],
  components: {
    PlayListEditorComponent: () => import('./PlayListEditor.vue'),
    MediumIcon
  },
  async created () {
    await this.loadData()
  },
  async updated () {
  },
  watch: {
    medium: async function (newVal, oldVal) {
      await this.loadData()
    },
    playlistScreensSwitch: async function (newVal, oldVal) {
      if (newVal === 'duplicates') this.findDuplicates()
    },
    searchByStringInput: async function (newVal, oldVal) {
      if (newVal.length === 0) {
        this.searchString = ''
        this.fireSearchByString()
      }
    }
  },
  data () {
    return {
      errors: {},
      playlistsFullPath: undefined,
      playListEditorSelector: undefined,
      playlistEdited: undefined,
      playitemIdSelected: undefined,
      playlistScreensSwitch: 'PlayListDesktop',
      duplicates: undefined,
      forceDisplayAll: true,
      displayDetails: true,
      tooManyAppearancesTreshhold: 2000,
      manyAppearancesTreshhold: 200,
      searchByString: '',
      searchByStringInput: '',
      searchString: '',
      occurrencesRawData: undefined,
      playtemsWithExceptions: [],
      itemsCount: null,
      loading: false
    }
  },
  methods: {
    fireSearchByString () {
      this.searchString = this.searchByStringInput
    },
    toggleForceDisplayAll () {
      this.forceDisplayAll = !this.forceDisplayAll
    },
    nameOfDestopByLocalPlaylistId (pl) {
      const desktop = this.$store.state.Device.desktop_list.find(dt => dt.LocalPlayList === pl.id)
      if (!desktop) {
        return pl.fullPath.mediaNames[0]
      }
      const device = this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
      return desktop.name.length > 0 && desktop.name !== 'single' ? `${device.name}-${desktop.name}` : `${device.name}`
    },
    async editPlayListInPlayItemContext (mediumId, playitemId, playitemPath, pl) {
      if (this.playlistScreensSwitch === 'PlayListLibraryRoot' || this.playlistScreensSwitch === 'duplicates') {
        this.$emit('loadPathInLibrary', pl.fullPath.mediaIds)
        return
      }
      let mediumFull = this.$store.state.Medium.media_list.find(medium => medium.id === parseInt(mediumId))
      if (!mediumFull && pl.type === 'PlayListDesktop') {
        mediumFull = await this.$store.dispatch('Medium/getMedium', {
          data: mediumId,
          options: { populate: false }
        })
      }
      if (!mediumFull || mediumFull.type.indexOf('PlayListLibrary') > -1) return
      this.playlistEdited = mediumFull
      this.playitemIdSelected = playitemId
      this.playListEditorSelector = playitemPath
    },
    makeRichPath (playlistWithFullPath) {
      if (!playlistWithFullPath) {
        return {
          mediaNames: [],
          mediaIds: [],
          playlistitemsIds: []
        }
      }
      return {
        mediaNames: playlistWithFullPath.pathSplitted,
        mediaIds: playlistWithFullPath.pathByMediumId.split('/'),
        playlistitemsIds: playlistWithFullPath.pathByPlaylistitemid.split('/').map(id => parseInt(id))
      }
    },
    loadEditMediumInMediaEditor (item) {
      this.$emit('loadEditMediumInMediaEditor', item)
    },
    // May be easily enriched this way:
    // http://localhost:8888/playlistitem?where={"id":{"in":[0,592,591,601]}}&populate=PlayListItem_DaytimeRestrictions,PlayListItem_VisualRestrictions

    async loadData () {
      let medium
      if (Array.isArray(this.medium)) {
        if (this.medium.length > 1) {
          return []
        } else {
          medium = this.medium[0]
        }
      } else {
        medium = this.medium
      }
      this.playlistsFullPath = undefined
      this.occurrencesRawData = (await Vue.axios.post('medium/findPlaylistsAffectedFullPath', { 'Medium': medium.id })).data
      this.playlistsFullPath = this.occurrencesRawData.occurrences
      this.playtemsWithExceptions = this.occurrencesRawData.playtemsWithExceptions.filter(pi => pi.playForbiddenInMedia !== '[]' || pi.playOnlyInMedia !== '[]')
      // get rid of unneccesary library paths
      const libraryItem = this.playlistsFullPath
        .filter(pla => pla.type === 'PlayListLibraryRoot')
        .filter(pla => this.pathContainsOnlyLibraryFolders(pla))
      this.playlistsFullPath = this.playlistsFullPath.filter(pla => !pla.type.startsWith('PlayListLibrary'))
      if (this.playlistsFullPath.length > 20000) this.displayDetails = false
      this.playlistsFullPath.push(libraryItem[0])
      for (let index = 0; index < this.playlistsFullPath.length; index++) {
        if (this.playlistsFullPath[index]) {
          this.playlistsFullPath[index].fullPath = this.makeRichPath(this.playlistsFullPath[index])
        }
      }
    },
    async findDuplicates () {
      this.duplicates = []
      const mediumFileId = this.medium.File.id ? this.medium.File.id : this.medium.File
      const dupMedia = this.$store.state.Medium.media_list.filter(m => m.File === mediumFileId).filter(m => !m.type.startsWith('PlayList'))
      for (const dupMedium of dupMedia) {
        const affectedPlaylists = (await Vue.axios.post('medium/findPlaylistsAffectedFullPath', { 'Medium': dupMedium.id })).data.occurrences
        const affectedLibrary = affectedPlaylists.filter(playlistAffected => this.pathContainsOnlyLibraryFolders(playlistAffected))[0]
        affectedLibrary.fullPath = this.makeRichPath(affectedLibrary)
        affectedLibrary.originalPath = JSON.parse(JSON.stringify(affectedLibrary.fullPath)).mediaNames
        for (let index = 0; index < affectedLibrary.fullPath.mediaNames.length - 1; index++) {
          affectedLibrary.fullPath.mediaNames[index] = this.shortenStringWithDots(affectedLibrary.fullPath.mediaNames[index], this.getDesiredLengthOfPathItem(affectedLibrary))
        }
        this.duplicates.push(affectedLibrary)
      }
    },
    pathContainsOnlyLibraryFolders (path) {
      const libraryFolders = [
        ...this.$store.state.Medium.media_types.find(type => type.name === 'PlayListLibraryRoot').media,
        ...this.$store.state.Medium.media_types.find(type => type.name === 'PlayListLibraryFolder').media
      ]
      const pathToItem = path.pathByMediumId.split('/')
      pathToItem.pop()
      for (const mediumId of pathToItem) {
        if (!libraryFolders.includes(parseInt(mediumId))) {
          return false
        }
      }
      return true
    },
    getDesiredLengthOfPathItem (playlistAffected) {
      const maxCharacters = parseInt(window.innerWidth / 1920 * 120)
      if (maxCharacters < playlistAffected.fullPath.mediaNames.join('').length) {
        return parseInt(maxCharacters / playlistAffected.fullPath.mediaNames.length)
      } else {
        return 85
      }
    },
    isExcepted (pl) {
      if (!this.displayDetails) return false
      const exceptionsRelevant = this.playtemsWithExceptions.filter(pe => pl.fullPath.playlistitemsIds.includes(pe.id))
      const exceptionsForbidden = exceptionsRelevant.filter(er => er.playForbiddenInMedia !== '[]')
      const exceptionsPlayOnly = exceptionsRelevant.filter(er => er.playOnlyInMedia !== '[]')
      for (const exceptionForbidden of exceptionsForbidden) {
        if (JSON.parse(exceptionForbidden.playForbiddenInMedia).includes(JSON.parse(pl.fullPath.mediaIds[0]))) {
          return true
        }
      }
      for (const exceptionPlayOnly of exceptionsPlayOnly) {
        if (!JSON.parse(exceptionPlayOnly.playOnlyInMedia).includes(JSON.parse(pl.fullPath.mediaIds[0]))) {
          return true
        }
      }
      return false
    },
    filterByString (playlistsAffected) {
      if (this.searchString.length < 4) return playlistsAffected
      return playlistsAffected.filter(pl => pl.path.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1 ||
      this.nameOfDestopByLocalPlaylistId(pl).toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
      )
    }
  },
  computed: {
    allExceptions () {
      if (!this.playlistsFullPath) return
      let exceptions = []
      for (const pl of this.playlistsFullPath) {
        if (!pl.playForbiddenInMedia && !pl.playOnlyInMedia) continue // && !pl.playOnlyInMedia
        exceptions.push({
          pathByMediumId: pl.pathByMediumId,
          pathByPlaylistitemid: pl.pathByPlaylistitemid,
          playForbiddenInMedia: pl.playForbiddenInMedia,
          playOnlyInMedia: pl.playOnlyInMedia
        })
      }
      return exceptions
    },
    items () {
      let result
      if (this.playlistScreensSwitch === 'duplicates') {
        return this.duplicates
      }
      if (!this.playlistsFullPath) return
      if (this.playlistsFullPath.length > this.tooManyAppearancesTreshhold && this.playlistScreensSwitch !== 'PlayListLibraryRoot' && !this.forceDisplayAll) return []
      let playlistsAffected = this.playlistsFullPath
      playlistsAffected = playlistsAffected.filter(playlistAffected => playlistAffected.type === this.playlistScreensSwitch)
      if (this.playlistScreensSwitch === 'PlayListLibraryRoot') {
        playlistsAffected = playlistsAffected
          .filter(playlistAffected => this.pathContainsOnlyLibraryFolders(playlistAffected))
      }

      if (this.searchString.length >= 4) {
        playlistsAffected = this.filterByString(playlistsAffected)
      }
      for (const playlistAffected of playlistsAffected) {
        playlistAffected.path.replace(/\//g, ' / ')
        playlistAffected.originalPath = JSON.parse(JSON.stringify(playlistAffected.fullPath.mediaNames))
      }

      const key = this.playlistScreensSwitch === 'PlayListDesktop' ? 'id' : 'path'

      result = this.displayDetails ? playlistsAffected : [...new Map(playlistsAffected.map((pl) => [pl[key], pl])).values()]
      if (result.length > this.manyAppearancesTreshhold) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.itemsCount = result.length
        return result.splice(0, this.manyAppearancesTreshhold)
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.itemsCount = null
        return result
      }
    },

    showMediumDuplicates () {
      if (!this.medium || !this.medium.type) return false
      if (!this.medium || this.medium.type.startsWith('PlayList')) return false
      return this.$store.state.User.user.Networks.find(n => n.id === this.$store.state.User.user.lastNetworkId).allowMediaDuplicates
    },
    displayAppearances () {
      if (this.forceDisplayAll) return true
      if (this.playlistScreensSwitch === 'PlayListLibraryRoot' || this.playlistScreensSwitch === 'duplicates') return true
      return this.playlistsFullPath && this.playlistsFullPath.length < this.tooManyAppearancesTreshhold
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.title {
  font-size: $--font-size-big;
}
.appearance-row, .row {
  .icon {
    color: $--color-text-secondary;
  }
  &.danger {
    background-color: $--color-danger-lighter;
    .subject-item {
      text-decoration: line-through;
    }
  }
  .searchByString-input {
    width: 200px;
    margin-right: 20px;
    .append-icon {
      padding-left: 13px;
    }
  }
}
.appearance-row {
  border-bottom: $--border-light;
  padding: 5px 20px;
}
.row {
  padding: 5px 20px;
}
.items-container {
  border-bottom: $--border-light;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.slash {
  color: $--color-warning;
  font-weight: bold;
  padding: 0px 5px 0px 5px;
}
.subject-item {
  font-size: $--font-size-base;
}
.medium-icon {
  padding-right: 10px;
  color:  $--color-primary-light-1;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // justify-items: center;
  font-size: $--font-size-base;
  span {
    font-size: $--font-size-base;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumInPlaylists.vue